/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Queues_Children_CoundInputs */

const en_tables_queues_children_cound = /** @type {(inputs: Tables_Queues_Children_CoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cound`)
};

const de_tables_queues_children_cound = /** @type {(inputs: Tables_Queues_Children_CoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Untergeordnete`)
};

/**
* | output |
* | --- |
* | "Cound" |
*
* @param {Tables_Queues_Children_CoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_queues_children_cound = /** @type {((inputs?: Tables_Queues_Children_CoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Queues_Children_CoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_queues_children_cound(inputs)
	return de_tables_queues_children_cound(inputs)
});